module.exports = __webpack_public_path__ + "static/img/syokusai_logo.7aae926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/syokusai_logo.png
// module id = AQG1
// module chunks = 0